var _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_4100",
    "data-name": "Gruppe 4100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.845,
    height: 85.925,
    viewBox: "0 0 89.845 85.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12167",
    "data-name": "Pfad 12167",
    d: "M.754,36.55C-1.2,24.828-.543,5.421,17.418,4.692S36.41-2.549,48.424,1.106,71.433,33.874,67.311,51.192C65.1,60.474,44.645,77.856,27.779,73.1,13.255,69.012,1.975,43.891.754,36.55Z",
    transform: "translate(71.048 0) rotate(74)",
    fill: "#1c9d87",
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(44.922 52.962)",
    fill: "#1c9d87",
    fontSize: 30,
    fontFamily: "Rubik-Bold, Rubik",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/number_3.a15f5e55d0178f20d8117335b2956825.svg";
export { ForwardRef as ReactComponent };